import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="list-search"
//
// Pure client-side filtering of a static list already in the DOM. Each
// filterable item carries data-list-search-target="item" and a
// data-search-text attribute (pre-lowercased on the server). Typing in the
// input hides non-matching items; an optional "empty" target is shown when
// nothing matches. No network round-trip.
export default class extends Controller {
  static targets = ["input", "item", "empty"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ""
    let visible = 0

    this.itemTargets.forEach((item) => {
      const haystack = item.dataset.searchText || item.textContent.toLowerCase()
      const match = query === "" || haystack.includes(query)
      item.classList.toggle("hidden", !match)
      if (match) visible += 1
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible !== 0)
    }
  }
}
